import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { rootRoute } from '@/tenant/root'
import { appState } from '@/appState'

export const authProvidersRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/auth-providers',
    component: lazyRouteComponent(() => import('./AuthProviders'), 'AuthProviders'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        const authProvidersSettings = await client.tenants.getTenantAuthProviders.query(
            {
                tenantId: appState.tenant!._id.toString(),
            },
            { signal: abortController.signal }
        )

        return {
            authProvidersSettings,
        }
    },
})
